module.exports = __webpack_public_path__ + "whatsapp.png?cc7ed84031a39e69a28d9a007c06d56f";


//////////////////
// WEBPACK FOOTER
// ./assets/images/whatsapp.png
// module id = 1640
// module chunks = 0